
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M6 17C3.79086 17 2 15.2091 2 13C2 10.7909 3.79086 9 6 9C6.02767 9 6.05528 9.00028 6.08282 9.00084C6.55855 6.16271 9.02671 4 12 4C14.9733 4 17.4415 6.16272 17.9172 9.00085C17.9447 9.00029 17.9723 9 18 9C20.2091 9 22 10.7909 22 13C22 15.2091 20.2091 17 18 17"></path><path d="M12.0006 14.0005C13.1634 14.0005 14.106 13.0579 14.106 11.8951C14.106 10.7324 13.1634 9.78976 12.0006 9.78976C10.8378 9.78976 9.89522 10.7324 9.89522 11.8951C9.89522 13.0579 10.8378 14.0005 12.0006 14.0005ZM12.0006 14.0005L12.0006 17.5007C12.0006 19.1576 10.6575 20.5007 9.00061 20.5007"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiIot",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
